// extracted by mini-css-extract-plugin
export default {"sideNavContainer":"sidenav_sideNavContainer__+XX58"};